import { Component } from '@angular/core';
import { LoaderService } from '../services/loader.service';
import { CommonModule } from '@angular/common';

@Component({
    standalone: true,
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    imports: [CommonModule]
})
export class LoaderComponent {
  constructor(public loader: LoaderService,) {
    this.loader.showSpinner.next(false);
  }
}
